import { StyledStringProps } from '@acorns/web-utils'
import React, { useCallback, useState } from 'react'

import { PageName } from 'generated/types'

import { ExternalNavbarProps, NavigationBar } from '../NavigationBar'
import { ButtonContainer, Separator } from '../shared-styled-components'
import { ContentContainer, FooterContainer, Headline, Page, Subtitle } from './styled-components'
import { FunnelContent } from '../FunnelContent'
import { TestIDs } from 'test/utils/testIds'

interface Props {
  headlineText?: string | React.FC<StyledStringProps>
  subtitleText?: string
  pageName: PageName
  footer?: React.ReactNode
  button: React.ReactNode
  isMainSignUpPage?: boolean // this should only be used for the email/password screens
  className?: string // only use for extending the styles of the template
  children: React.ReactNode
  navigationBar?: ExternalNavbarProps
  eventObjectName: string // this is the object name of the page that the user is currently on
}

export const CONTENT_CONTAINER_CLASSNAME = 'page-template-content-container'
export const FOOTER_CONTAINER_CLASSNAME = 'page-template-footer-container'

export const PageLayout = (props: Props) => {
  const [footerHeight, setFooterHeight] = useState(0)
  const footerRef = useCallback((node) => {
    if (!node) return
    setFooterHeight(node.clientHeight)
  }, [])

  return (
    <div className={props.className}>
      <FunnelContent eventObjectName={props.eventObjectName} pageName={props.pageName} />
      <NavigationBar
        pageName={props.pageName}
        eventObjectName={props.eventObjectName}
        {...props.navigationBar}
      />
      <Page
        content={
          <>
            <ContentContainer className={CONTENT_CONTAINER_CLASSNAME} offsetHeight={footerHeight}>
              {!props.isMainSignUpPage && (
                <Headline
                  data-testid={TestIDs.PAGE_LAYOUT.HEADLINE}
                  hasExtraSpacing={!props.subtitleText}
                >
                  {props.headlineText}
                </Headline>
              )}
              {props.subtitleText && (
                <Subtitle data-testid={TestIDs.PAGE_LAYOUT.SUBTITLE}>{props.subtitleText}</Subtitle>
              )}
              {props.children}
            </ContentContainer>
            {(props.button || props.footer) && (
              <>
                <Separator />
                <FooterContainer className={FOOTER_CONTAINER_CLASSNAME} ref={footerRef}>
                  {props.footer}
                  {props.button && <ButtonContainer>{props.button}</ButtonContainer>}
                </FooterContainer>
              </>
            )}
          </>
        }
      />
    </div>
  )
}

export default PageLayout
